import React, { useEffect, useState, useRef } from 'react'
import { Link, useParams, useHistory } from 'react-router-dom'
import {
  IonContent,
  IonGrid,
  IonRow,
  IonButton,
  IonIcon,
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react'
import {
  chevronForwardOutline,
  chevronBackOutline
} from 'ionicons/icons'
import { setNewsMetaTags } from '../../services/metatags'
import { setView } from '../../services/analytics'
import { setPixelView } from '../../services/fbPixel'
import { NewsRadioCard } from '../../components/common/NewsRadioCard'
import { Advertisement } from '../../components/common/Advertisement'
import { NewsRadioCardSkeleton } from '../../components/skeletons/NewsRadioCardSkeleton'
import { getContentFeed } from '../../services/api/contents'
import { newsSettings } from '../../config/pages'
import './styles.scss'

const News = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  const [contents, SetContents] = useState([])
  const contentRef = useRef()
  const { page, tag } = useParams()
  const history = useHistory()

  useIonViewDidEnter(() => {
    setIsVisible(true)
    setNewsMetaTags()
    setView(window.location.pathname)
    setPixelView()
  })

  useIonViewWillLeave(() => {
    setIsVisible(false)
  })

  useEffect(() => {
    const params = {
      limit: 12,
      section: 'news',
      offset: parseInt(page) - 1
    }
    if (typeof tag !== 'undefined') {
      params.tag = tag
    }
    getContentFeed(params)
      .then((response) => {
        SetContents(response)
      }).catch(() => {
        SetContents([])
        history.push('/404')
      })
    return () => {
      SetContents([])
    }
  }, [page, tag])

  if (isVisible === false) return null

  return (
    <IonContent
      ref={contentRef}
      fullscreen
      className='news-page page-wrapper'
    >
      <section>
        <Advertisement />
      </section>

      <section className='feed-wrapper'>
        {contents.length === 0 &&
          <IonGrid>
            <IonRow>
              <NewsRadioCardSkeleton />
              <NewsRadioCardSkeleton />
              <NewsRadioCardSkeleton />
              <NewsRadioCardSkeleton />
              <NewsRadioCardSkeleton />
              <NewsRadioCardSkeleton />
              <NewsRadioCardSkeleton />
              <NewsRadioCardSkeleton />
              <NewsRadioCardSkeleton />
            </IonRow>
          </IonGrid>}
        {contents.length > 0 &&
          <IonGrid>
            <IonRow>
              {contents.map(content =>
                <NewsRadioCard
                  key={content.id}
                  content={content}
                />
              )}
            </IonRow>
          </IonGrid>}
      </section>

      <section className='buttons-wrapper'>
        {page > 1 &&
          <Link to={`/news/${parseInt(page) - 1}${typeof tag !== 'undefined' ? `/${tag}` : ''}`}>
            <IonButton className='previous'>
              <IonIcon icon={chevronBackOutline} />
            </IonButton>
          </Link>}

        {newsSettings.navigation.rows === contents.length &&
          <Link to={`/news/${parseInt(page) + 1}${typeof tag !== 'undefined' ? `/${tag}` : ''}`}>
            <IonButton className='next'>
              <IonIcon icon={chevronForwardOutline} />
            </IonButton>
          </Link>}
      </section>

      <section>
        <Advertisement />
      </section>
    </IonContent>
  )
}

export default News
